import React, { memo } from 'react'
import NumberFormat from 'react-number-format'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import COLORS from 'components/Toolkit/colors'
import Label from 'components/Toolkit/Text/Label'

// Just a random note, HTML doesn't support treating the date text as a placeholder
// So having the placeholder color and then then input color didn't make sense
const StyledNumberFormat = styled(NumberFormat)`
  background: ${COLORS.PRIMARY.COCONUT};
  border: ${(props) =>
    props.hasError
      ? `1.5px solid ${COLORS.ACCENTS.SALMON}`
      : `1px solid ${COLORS.LIGHT_NEUTRALS.MERCURY}`};
  box-sizing: border-box;
  border-radius: 10px;
  color: ${(props) =>
    props.type === 'date' ? COLORS.LIGHT_NEUTRALS.PARSNIP : COLORS.PRIMARY.PLUM}
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 168.68%;
  padding: 16px 22px;
  transition: border 200ms;
  width: 100%;

  &::placeholder {
    color: ${COLORS.LIGHT_NEUTRALS.PARSNIP};
  }

  &:focus {
    border: ${(props) =>
      props.hasError
        ? `1.5px solid ${COLORS.ACCENTS.SALMON}`
        : `1px solid ${COLORS.LIGHT_NEUTRALS.MERCURY}`};
  }
`

const StyledInputContainer = styled.div`
  margin: ${(props) => (props.hasLabel ? '25px 0' : '')};
`

function NumberMask({ label, value, onChange, hasError, ...otherProps }) {
  return (
    <StyledInputContainer hasLabel={Boolean(label)}>
      {label && <Label>{label}</Label>}
      <StyledNumberFormat
        value={value}
        onValueChange={(values) => onChange(values)}
        hasError={hasError}
        {...otherProps}
      />
    </StyledInputContainer>
  )
}

NumberMask.propTypes = {
  label: PropTypes.string,
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired
}

export default memo(NumberMask)
